module.exports = ".input-group {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.input-group-btn {\n  width: auto; }\n\n.input-group-btn .btn {\n    padding-left: 1em;\n    padding-right: 1em;\n    height: 100%; }\n\n.input-group-btn .btn .fal {\n      margin: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/forms/elements/components/select/select.component.scss
// module id = ./libs/chassis-core/src/app/forms/elements/components/select/select.component.scss
// module chunks = main